<template>
  <div class="container">
    <div v-for="(item, index) in settingList">
      <SettingItem :item="item"/>
    </div>
    <div v-if="isDev" @click="clearProfile">清除profile开启信息</div>
  </div>
</template>

<script>
import {ISDEV} from '@/env'
import SettingItem from '@/components/widgets/SettingItem'
import app from '@/AppData'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanApi'

export default {
  name: 'BasicSetting',

  components: {
    SettingItem
  },

  data () {
    let that = this
    return {
      isDev: ISDEV,
      settingList: [
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.8,
        },
        {
          title: '会员专属设置',
          tip: '@/../static/setting_vip_icon.png',
          tipWidth: 3,
          tipHeight: 1.4,
          desc: '选择助理声音，开场白等',
          // content: Constants.getVoiceRoleName(!app.isVip() ? 0 : app.getData().userSetting.voiceRole),
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              path: '/vip_setting_page'
            })
            lubanapi.reportseer('AICall_Setting_Page_Operating', '0')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.8
        },
        {
          title: '手机号码设置',
          desc: '帮你代接的号码',
          content: app.getData().userSetting.phoneNum,
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              name: 'changenumnotify',
              params: {
                from: 'changePhone'
              }
            })
            lubanapi.reportseer('AICall_Setting_Page_Operating', '1')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          title: '接听通知栏消息通知',
          desc: '来电后通过通知栏即时通知你',
          isSwitch: true,
          switch: app.getData().showNotification,
          onClick: function () {
            that.updateNotification()
            lubanapi.reportseer('AICall_Setting_Page_Operating', '2')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1,
        },
        {
          title: '代接模式设置',
          desc: '忙时接听、无人接听或挂断接听',
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              path: '/ai_pattern_page'
            })
            lubanapi.reportseer('AICall_Setting_Page_Operating', '3')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.8
        },
        {
          title: '服务开关',
          desc: '开启或关闭服务',
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              path: '/service_page'
            })
            lubanapi.reportseer('AICall_Setting_Page_Operating', '4')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.8
        },
        {
          title: '问题反馈',
          go: true,
          onClick: function () {
            console.log(this.title)
            // window.open("http://feedback.qq.com/?productId=5")
            jsbridge.openUrl('http://feedback.qq.com/?productId=5')
            lubanapi.reportseer('AICall_Setting_Page_Operating', '5')
          }
        },
      ]
    }
  },
  methods: {
    clearProfile () {
      console.log('clearProfile')
      let target = Object.assign({}, app.getData().userSetting, {phoneNum: ''})
      return lubanapi._authReq({
        name: 'reportProfile',
        method: 'post',
        data: {
          settingData: target
        }
      }).then(res => {
        console.log('clearProfile complete')
        console.log(res)
        app.initBaseData(true)
        alert('清除成功,请关闭网页重新打开')
      })
    },

    updateNotification () {
      if (app.getData().showNotification === true) {
        jsbridge.setShowNotification(false)
        app.setShowNotification(false)
      } else {
        jsbridge.setShowNotification(true)
        app.setShowNotification(true)
        jsbridge.checkNotificationPermission().then(res => {
          if (res === 0) {
            jsbridge.openNotificationPermission()
          }
        })
      }
    }
  }
}

</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;
}

</style>



// WEBPACK FOOTER //
// src/components/setting/BasicSetting.vue